/* eslint-disable */
export default {
  loginButton: 'Kirjaudu sisään',
  signupButton: 'Oletko uusi käyttäjä? Rekisteröidy',
  version: 'Versio',
} as const;

// @key: @#@"loginButton"@#@ @source: @#@"Sign In"@#@
// @key: @#@"signupButton"@#@ @source: @#@"New user? Sign Up"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
